import { DOCUMENT, Service, computed, inject, signal } from '@angular/core';

/**
 * Work that should not be cut short: imports, uploads, encrypting stored files. While any
 * runs, closing the tab asks first, and sign-out asks for confirmation (App).
 */
@Service()
export class BackgroundWork {
  private readonly running = signal(0);
  readonly busy = computed(() => this.running() > 0);

  constructor() {
    inject(DOCUMENT).defaultView?.addEventListener('beforeunload', (event) => {
      if (this.busy()) event.preventDefault();
    });
  }

  /** Runs `task`, counting it as work in progress until it settles. */
  async track<T>(task: () => Promise<T>): Promise<T> {
    this.running.update((n) => n + 1);
    try {
      return await task();
    } finally {
      this.running.update((n) => n - 1);
    }
  }
}
